














































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import JiatingzhuzhiCmp from "./jiatingzhuzhi.vue";
import Zhusu from "./zhusu.vue";
import Zhuyaozhengzhuangmingchen from "./zhuyaozhengzhuangmingchen.vue";
import Zhongyaoyinpian from "./zhongyaoyinpian.vue";
import Qitayongyao from "./qitayongyao.vue";
import ZiduanConfigDialog from "./ziduanConfigDialog.vue";
import ChengduSettingDialog from "./chengduSettingDialog.vue";
@Component({
  components: {
    JiatingzhuzhiCmp,
    Zhusu,
    Zhuyaozhengzhuangmingchen,
    Zhongyaoyinpian,
    Qitayongyao,
    ZiduanConfigDialog,
    ChengduSettingDialog
  }
})
export default class CustomTransferCmp extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  @Prop()
  private noDelete: any;
  @Prop()
  private noConfig: any;
  private cZiduan: any = {};
  private defaultValue: any = "";
  private ziduanConfigVisible: boolean = false;
  private dialogVisible: boolean = false;
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("delete", this.index);
  }
  /**
   * @description 单层多选删除一项
   */
  private deleteSingleLevelSelect(index) {
    this.ziduan.options.splice(index, 1);
  }
  /**
   * @description 多层多选删除第一层
   */
  private delelteFirstLevel(ziduan, index) {
    ziduan.splice(index, 1);
  }
  /**
   * @description 多层多选删除第二层
   */
  private delelteSecondLevel(ziduan, index) {
    ziduan.splice(index, 1);
  }
  /**
   * @description 多层多选打开设置面板
   */
  private setConfig(ev, checkbox) {
    ev = false;
    this.cZiduan = checkbox;
    this.dialogVisible = true;
  }
  /**
   * @description 打开字段配置弹窗
   */
  private openZiduanConfig(ev) {
    this.cZiduan = this.ziduan;
    this.ziduanConfigVisible = true;
  }
  /**
   * @description 打开多层多选的字段配置弹窗
   */
  private openZiduanDuocengConfig(line) {
    line.type = "多层多选";
    line.title = line.name;
    this.cZiduan = line;
    this.ziduanConfigVisible = true;
  }
}
